/**
 * Recursively deep freezes an object.
 * @template T
 * @param {T} obj - The object to freeze.
 * @returns {T} The frozen object.
 */
export function deepFreeze(obj) {
  // If obj is not an object or is already frozen, return it
  if (typeof obj !== 'object' || obj === null || Object.isFrozen(obj)) {
    return obj
  }

  // Retrieve the property names defined on the object
  const propNames = Object.getOwnPropertyNames(obj)

  // Freeze properties before freezing the object itself
  for (const name of propNames) {
    const value = obj[name]

    // If the property is an object (or array), recursively deep freeze it
    if (typeof value === 'object' && value !== null) {
      deepFreeze(value)
    }
  }

  // Freeze the object itself (arrays are objects too)
  return Object.freeze(obj)
}
